import { Injectable, signal } from '@angular/core';
import type { BreadcrumbDropdownMenuItem } from '../../breadcrumb.interfaces';

@Injectable()
export class BreadcrumbDropdownItemStore {
  readonly dropdownMenuItems = signal<BreadcrumbDropdownMenuItem[]>([]);
  readonly selectedItemRoute = signal<string | null>(null);
}
